import React, { Fragment, useState } from "react"
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import classnames from "classnames"
import './style.scss';
import navConfigDonor from "../../../../../configs/navConfigDonors";
import navigationConfig from "../../../../../configs/navigationConfig";

function SideMenuContent() {
  const { roleFromClaims } = useSelector(state => state.auth.login);
  const [isSubMenuActive, setIsSubMenuActive] = useState(false);
  const config = roleFromClaims === "admin" ? navigationConfig : navConfigDonor;

  return config.map(item => (
    item.type === "subMenu" ? <Fragment><li className="nested-sidenav-text" key={item.title}>
      <a onClick={() => setIsSubMenuActive(!isSubMenuActive)} className="navigation-header">
        {item.icon}
        <span style={{ textTransform: "none" }}>{item.title}</span>
      </a>
      <ui className={classnames({
        hidden: !isSubMenuActive
      })}>
        {item.childrens.map((item) => <li className="sidenav-text" key={item.title}><Link
          key={`group-header-${item.title}`}
          className="navigation-header"
          to={item.navLink}
        >
          {item.icon}
          <span style={{ textTransform: "none" }}>{item.title}</span>
        </Link></li>)}
      </ui>
    </li>
    </Fragment > : <li className="sidenav-text" key={item.title}>
      <Link
        className="navigation-header"
        key={`group-header-${item.title}`}
        to={item.navLink}
      >
        {item.icon}
        <span style={{ textTransform: "none" }}>{item.title}</span>
      </Link>
    </li>
  ))
}

export default SideMenuContent;
